<template>
  <div>
    <textarea @input="checkInput('model',$event)" v-model="model" :id="inputId" :class="this.className" v-bind="[$attrs]" @keyup="calculateRemaining" @blur="calculateRemaining" :maxlength="maxlength"></textarea>
    <label :for="inputId" class="text-right limit">Limit: <span v-bind:class="{'text-danger': generateErr }">{{typedCount}} / {{maxlength}}</span></label>
  </div>
</template>
<script>

export default {
  inheritAttrs: false,
  created(){
    this.inputId = "textarea_" + Math.random().toString().replace('.', '');
  },
  props :{
    value: {
      type: String,
      required: false,
    },
    maxlength: {
      type: Number,
      default: 2000,
      required: false,
    },
    className:{
      type: String
    },
    allowExceed:{
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      generateErr: false,
      inputId: null
    }
  },
  computed:{
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);        
      },
    },
    typedCount(){
      return this.model?.length ?? 0;
    }
  },
  methods: {
    checkInput(value, event) {
        // Check for invalid characters
        if (/[<>]/.test(event.target.value)) {
            alert(this.translate('errors.invalidSymbols'))
            const editedText = ""
            this.$set(this, value, editedText)
        } else {
            this.$set(this, value, event.target.value)
        }
    },
    calculateRemaining() {
      this.generateErr = this.typedCount > this.maxlength;

      if(this.generateErr && !this.allowExceed)
         this.model = this.model.substring(0, this.maxlength);
    }
  },
};
</script>
<style scoped>
.limit {
  font-size:0.7em;
  position:relative;
  margin-top: -1rem;
  margin-right:1rem;
  margin-bottom: 0;
  opacity: 0.8;
  display:block;
  cursor:text;
  float:right;
}
</style>